import React, { useState, useMemo, useCallback, useEffect } from "react";
import { remove } from "lodash";
import { useTable, useSortBy, useFilters, usePagination } from "react-table";
import Pagination from "components/common/Pagination";
import ReactTableWrapper from "components/reacttable/reacttbl.style";
import { Button } from "reactstrap";
import HeaderComponent from "components/reacttable/subcomponents/HeaderComponent";
import FilterComponent from "components/reacttable/subcomponents/FilterComponent";
import DropdownFilterComponent from "components/reacttable/subcomponents/DropdownFilterComponent";

const ProductosTable = props => {
  const [productsData, setProductsData] = useState(props.data);
  const [productData, setProductData] = useState({});
  const [modal, setModal] = useState(false);
  const [warningAlert, setWarningAlert] = useState(false);

  useEffect(() => {
    setProductsData(props.data);
  }, [props.data]);

  const deleteClick = useCallback(() => {
    props.handleInactive(productData);
    const array = productsData;
    remove(array, function(n) {
      return n.id === productData.id;
    });
    setProductsData([...array]);
    setWarningAlert(false);
  }, [productsData, props, productData]);

  const editClick = useCallback(data => {
    setProductData(data);
    setModal(true);
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Código Interno"
            />
          );
        },
        Filter: FilterComponent,
        placeholder: "Código Interno",
        accessor: "internal_code"
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Nombre"
            />
          );
        },
        Filter: FilterComponent,
        placeholder: "Nombre del producto",
        accessor: "name"
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Descripción"
            />
          );
        },
        Filter: FilterComponent,
        placeholder: "Descripción del producto",
        accessor: "description"
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Marca"
            />
          );
        },
        Filter: DropdownFilterComponent,
        placeholder: "Marca del producto",
        accessor: "brand"
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Familia"
            />
          );
        },
        Filter: DropdownFilterComponent,
        placeholder: "Familia del producto",
        accessor: "category.displayable_text"
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Subfamilia"
            />
          );
        },
        Filter: DropdownFilterComponent,
        placeholder: "Subfamilia del producto",
        accessor: "subfamily"
      },
      {
        Header: tableInstance => {
          return (
            <HeaderComponent
              isSortedDesc={tableInstance.column.isSortedDesc}
              title="Acción"
            />
          );
        },
        accessor: "id",
        disableSortBy: true,
        disableFilters: true,
        Cell: tableInstance => {
          return (
            <div className="react-action-class wide-cell">
              <button
                className="react-table-edit-button"
                onClick={() => editClick(tableInstance.row.original)}
              >
                <i className="fas fa-edit" />
              </button>
              <button
                className={`${
                  props.isTrashcan
                    ? "react-table-view-button"
                    : "react-table-delete-button"
                }`}
                onClick={() => {
                  setProductData(tableInstance.row.original);
                  setWarningAlert(true);
                }}
              >
                <i
                  className={`fas fa-${props.isTrashcan ? "recycle" : "trash"}`}
                />
              </button>
            </div>
          );
        }
      }
    ],
    [editClick, props.isTrashcan]
  );

  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    setAllFilters,
    page,
    headerGroups,
    pageCount,
    gotoPage,
    state: { pageIndex, filters }
  } = useTable(
    {
      data: productsData,
      columns: columns,
      initialState: {
        pageSize: 10,
        pageIndex: 0
      }
    },
    useFilters,
    useSortBy,
    usePagination
  );

  return (
    <>
      <ReactTableWrapper {...props}>
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1">
              <span className="hash"># </span> Catálogo de productos
            </div>
            {filters && filters.length > 0 && (
              <div className="mr-10">
                <Button
                  className="c-btn ma-5 c-info"
                  onClick={() => setAllFilters([])}
                >
                  <i className="fas fa-filter mr-10" />
                  Quitar filtros
                </Button>
              </div>
            )}
            <div className="mr-10">
              <Button
                className="c-btn ma-5 c-primary"
                //onClick={() => formAction("add")}
              >
                <i className="fas fa-plus mr-10" />
                Nuevo
              </Button>
            </div>
            <div>
              <Button
                className="c-btn ma-5 c-warning"
                onClick={props.toggleTrashcan}
              >
                <i
                  className={`mr-10 fas fa-${
                    props.isTrashcan ? "recycle" : "trash"
                  }`}
                />
                Papelera
              </Button>
            </div>
          </div>
          <div className="table-container text-center overflow-auto">
            <table
              border={1}
              className="custom-react-table-theme-class"
              {...getTableProps()}
            >
              <thead>
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(header => (
                      <th
                        {...header.getHeaderProps(
                          header.getSortByToggleProps()
                        )}
                      >
                        <div>{header.render("Header")}</div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(header => {
                      return (
                        <td
                          {...header.getHeaderProps(
                            header.getSortByToggleProps()
                          )}
                        >
                          <div>
                            {header.canFilter ? header.render("Filter") : null}
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                ))}
                {page.map(row => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map(cell => (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Pagination
            onPageChange={gotoPage}
            pages={pageCount}
            page={pageIndex}
          />
        </div>
      </ReactTableWrapper>
    </>
  );
};

export default ProductosTable;
